export type BasicToken = { address: string; logoUri?: string; logoURI?: string }

export function getTokenLogoUri(
  tokens: BasicToken[] | undefined,
  address: string | undefined,
  opts?: {
    cdnBase?: string
    placeholder?: string
  }
): string {
  const cdnBase = opts?.cdnBase ?? 'https://static.kodiak.finance/tokens'
  const placeholder = opts?.placeholder ?? '/assets/icons/custom_token.svg'

  if (!address) return placeholder
  const addr = address.toLowerCase()

  const token = tokens?.find((t) => t.address.toLowerCase() === addr)
  const direct = token?.logoUri ?? token?.logoURI
  return direct || `${cdnBase}/${addr}.png` || placeholder
}
